import managementRoutes from '@/navigation/vertical/admin/management'
import technicalRoutes from '@/navigation/vertical/admin/technical'
import contentRoutes from '@/navigation/vertical/admin/content'

const items = [
  {
    title: 'menu.admin-home',
    route: 'admin:home',
    icon: 'HomeIcon',
  },
  ...managementRoutes,
  ...contentRoutes,
  ...technicalRoutes,
]

export default items.map(item => ({ ...item, admin: true }))
